import React from 'react';
import ReactDOM from 'react-dom/client';
// import 'antd/dist/reset.css';
import './styles/globals.css';
import './index.scss';

import { HelmetProvider } from 'react-helmet-async';
import { ConfigProvider, App as AntdApp, theme } from 'antd';
import zhCN from 'antd/es/locale/zh_CN';
import { StyleProvider } from '@ant-design/cssinjs';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import localeData from 'dayjs/plugin/localeData';
import weekday from 'dayjs/plugin/weekday';
import ReactGA from 'react-ga4';
import TA from 'th-analytics';
import { taUtil } from './utils';
import App from './App';

import reportWebVitals from './reportWebVitals';
import { AntdThemeToken } from "@/config"

if (import.meta.env.VITE_GA_CODE) {
  ReactGA.initialize(import.meta.env.VITE_GA_CODE);
}
if (import.meta.env.VITE_TA_CODE) {
  TA.initialize({
    server: 'https://analytics.thape.com.cn/logs',
    appId: import.meta.env.VITE_TA_CODE,
    userIdentifier: taUtil.getUserIdentifier(),
  });
}

dayjs.locale('zh-cn');
dayjs.extend(isBetween);
dayjs.extend(isSameOrBefore);
dayjs.extend(isSameOrAfter);
dayjs.extend(customParseFormat);
dayjs.extend(relativeTime);
dayjs.extend(localeData);
dayjs.extend(weekday);

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <StyleProvider layer>
        <ConfigProvider locale={zhCN} theme={{
          token: AntdThemeToken,
        }}>
          <AntdApp>
            <App />
          </AntdApp>
        </ConfigProvider>
      </StyleProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
